import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection } from '@iotv/iotv-v3-types';

const typeName = 'SoilMoistureGroup';

export type SoilMoistureGroupProps = {
  saturationPoint?: number;
  fieldCapacity?: number;
  permanentWiltingPoint?: number;
  soilTemperatureLevel?: number;
  soilTemperatureChanges?: number;
  soilMoistureLevel?: number;
  soilMoistureChanges?: number;
};

export class SoilMoistureGroup extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  saturationPoint?: number;
  fieldCapacity?: number;
  permanentWiltingPoint?: number;
  soilTemperatureLevel?: number;
  soilTemperatureChanges?: number;
  soilMoistureLevel?: number;
  soilMoistureChanges?: number;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      SaturationPoint: {
        type: 'Number',
        editable: true,
        label: 'Saturation Point',
        name: 'SaturationPoint',
        description: 'Soil moisture level (kPa) maximum saturation threshold, for grouped and individual Soil Moisture objects',
      },
      FieldCapacity: {
        type: 'Number',
        editable: true,
        label: 'Field Capacity',
        name: 'FieldCapacity',
        description: 'Soil moisture level (kPa) optimal saturation threshold, for grouped and individual Soil Moisture objects',
      },
      PermanentWiltingPoint: {
        type: 'Number',
        editable: true,
        label: 'Permanent Wilting Point',
        name: 'PermanentWiltingPoint',
        description: 'Soil moisture level (kPa) minimum saturation threshold, for grouped and individual Soil Moisture objects',
      },
      SoilTemperatureLevel: {
        type: 'Number',
        editable: true,
        label: 'Soil Temperature Level',
        name: 'SoilTemperatureLevel',
        description: 'Average soil temperature level for grouped Soil Moisture objects',
      },
      SoilTemperatureChanges: {
        type: 'Number',
        editable: true,
        label: 'Soil Temperature Changes',
        name: 'SoilTemperatureChanges',
        description: 'Amount of change in soil temperature level between two periods, for grouped and individual Soil Moisture objects',
      },
      SoilMoistureLevel: {
        type: 'Number',
        editable: true,
        label: 'Soil Moisture Level',
        name: 'SoilMoistureLevel',
        description: 'Average soil moisture level for grouped Soil Moisture objects',
      },
      SoilMoistureChanges: {
        type: 'Number',
        editable: true,
        label: 'Soil Moisture Changes',
        name: 'SoilMoistureChanges',
        description: 'Amount of change in soil moisture level between two periods, for grouped and individual Soil Moisture objects',
      },
    };
  };
}
